import React from 'react';
import styled from 'styled-components';

const ProgressContainer = styled.div`
  padding: 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
`;

const ProgressBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 1rem;
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: rgba(255,255,255,0.3);
    transform: translateY(-50%);
    z-index: 1;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    height: 2px;
    background: white;
    transform: translateY(-50%);
    z-index: 2;
    width: ${props => ((props.currentStep - 1) / (props.totalSteps - 1)) * 100}%;
    transition: width 0.3s ease;
  }
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 3;
  
  .step-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    
    ${props => {
        if (props.isCompleted) {
            return `
          background: white;
          color: #667eea;
          border-color: white;
        `;
        } else if (props.isActive) {
            return `
          background: white;
          color: #667eea;
          border-color: white;
          box-shadow: 0 0 0 4px rgba(255,255,255,0.3);
        `;
        } else {
            return `
          background: rgba(255,255,255,0.3);
          color: white;
          border-color: rgba(255,255,255,0.3);
        `;
        }
    }}
  }
  
  .step-label {
    font-size: 0.8rem;
    text-align: center;
    font-weight: 500;
    opacity: ${props => props.isActive || props.isCompleted ? 1 : 0.7};
    transition: opacity 0.3s ease;
    max-width: 100px;
    line-height: 1.2;
  }
  
  @media (max-width: 768px) {
    .step-label {
      font-size: 0.7rem;
      max-width: 80px;
    }
    
    .step-circle {
      width: 32px;
      height: 32px;
      font-size: 0.8rem;
    }
  }
`;

const StepTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

const steps = [
    { number: 1, label: 'Review Order', title: 'Review Your Order' },
    { number: 2, label: 'Customer Info', title: 'Contact Information' },
    { number: 3, label: 'Payment', title: 'Payment Method' },
    { number: 4, label: 'Confirmation', title: 'Order Confirmation' }
];

const CheckoutProgress = ({ currentStep, totalSteps, validatedSteps }) => {
    const currentStepInfo = steps.find(step => step.number === currentStep);

    return (
        <ProgressContainer>
            <ProgressBar currentStep={currentStep} totalSteps={totalSteps}>
                {steps.map((step) => {
                    const isActive = step.number === currentStep;
                    const isCompleted = validatedSteps.has(step.number) || step.number < currentStep;

                    return (
                        <Step
                            key={step.number}
                            isActive={isActive}
                            isCompleted={isCompleted}
                        >
                            <div className="step-circle">
                                {isCompleted && step.number < currentStep ? '✓' : step.number}
                            </div>
                            <span className="step-label">{step.label}</span>
                        </Step>
                    );
                })}
            </ProgressBar>

            <StepTitle>{currentStepInfo?.title || 'Checkout'}</StepTitle>
        </ProgressContainer>
    );
};

export default CheckoutProgress;
